import { useState } from "react";

export const useFilingModals = () => {
  // --- Upload Modal State ---
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  // --- Dependent Modal State ---
  const [isDependentModalOpen, setIsDependentModalOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  // --- Crypto / Gain-Loss Modal State ---
  const [showEnableUploadConfirmation, setShowEnableUploadConfirmation] =
    useState(false);
  const [showGenerateGainLossModal, setShowGenerateGainLossModal] =
    useState(false);
  const [selectedGainLossYear, setSelectedGainLossYear] = useState(null);
  const [gainLossMethod, setGainLossMethod] = useState("FIFO");

  // --- Expert / Signature Modal State ---
  const [show8879PrepareModal, setShow8879PrepareModal] = useState(false);
  const [showRequestSignatureModal, setShowRequestSignatureModal] =
    useState(false);
  const [showSignAuthModal, setShowSignAuthModal] = useState(false);
  const [showEfileStateUpdateModal, setShowEfileStateUpdateModal] =
    useState(false);
  const [efileStateUpdateService, setEfileStateUpdateService] = useState(null);
  const [efileStateUpdateNumber, setEfileStateUpdateNumber] = useState("");
  const [efileStateUpdateReason, setEfileStateUpdateReason] = useState("");

  // --- Process / Review Modal State ---
  const [showProcessCompleteModal, setShowProcessCompleteModal] =
    useState(false);
  const [showDemoReviewModal, setShowDemoReviewModal] = useState(false);
  const [showDemoWelcomeModal, setShowDemoWelcomeModal] = useState(false);
  const [showCusReviewIntroModal, setShowCusReviewIntroModal] = useState(false);
  const [showCusReviewModal, setShowCusReviewModal] = useState(false);
  const [showAcceptedPopup, setShowAcceptedPopup] = useState(false);
  const [isSigningModalOpen, setIsSigningModalOpen] = useState(false);

  return {
    // States
    isUploadModalOpen,
    setIsUploadModalOpen,
    selectedSource,
    setSelectedSource,
    selectedDocumentId,
    setSelectedDocumentId,
    isDependentModalOpen,
    setIsDependentModalOpen,
    showDeleteConfirmation,
    setShowDeleteConfirmation,
    showEnableUploadConfirmation,
    setShowEnableUploadConfirmation,
    showGenerateGainLossModal,
    setShowGenerateGainLossModal,
    selectedGainLossYear,
    setSelectedGainLossYear,
    gainLossMethod,
    setGainLossMethod,
    show8879PrepareModal,
    setShow8879PrepareModal,
    showRequestSignatureModal,
    setShowRequestSignatureModal,
    showSignAuthModal,
    setShowSignAuthModal,
    showEfileStateUpdateModal,
    setShowEfileStateUpdateModal,
    efileStateUpdateService,
    setEfileStateUpdateService,
    efileStateUpdateNumber,
    setEfileStateUpdateNumber,
    efileStateUpdateReason,
    setEfileStateUpdateReason,
    showProcessCompleteModal,
    setShowProcessCompleteModal,
    showDemoReviewModal,
    setShowDemoReviewModal,
    showDemoWelcomeModal,
    setShowDemoWelcomeModal,
    showCusReviewIntroModal,
    setShowCusReviewIntroModal,
    showCusReviewModal,
    setShowCusReviewModal,
    showAcceptedPopup,
    setShowAcceptedPopup,
    isSigningModalOpen,
    setIsSigningModalOpen,
  };
};
